export default class configurationSettings{
  constructor(){
    this.vendorColor = '#ff0000';
    this.store = null;
  }

  get stateTree() {
    return this.store.getState();
  }
}

export let ConfigurationSettings = new configurationSettings();



// WEBPACK FOOTER //
// ./src/settings/configurationSettings.js